import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";
import ContactCard from "./ContactCard";
import { Skeleton } from "@mui/material";

function AddContacts({ onClose, company_id }) {
  const [AddContactForm, setAddContactForm] = useState(false);
  const { setGlobalLoading, token } = useOutletContext();
  const [contacts, setContacts] = useState([]);
  const [oldCandidate, setOldCandidate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disabledFields, setDisabledFields] = useState(true);
  const [LiUrl, setLiUrl] = useState(true);
  const [candidate_id, setCandidate_id] = useState(null);
  const [NotAvailable, setNotAvailable] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  async function getContacts() {
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/companyinfo/get_contacts/${company_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setContacts(response.data.contacts);
    } catch (error) {
      setGlobalLoading(false);
      toastr.error(error);
    } finally {
      setGlobalLoading(false);
    }
  }

  const AddedContacts = useRef(false);

  useEffect(() => {
    if (AddedContacts.current) return;
    AddedContacts.current = true;
    getContacts();
  }, []);

  const normalizeLinkedInUrl = (input) => {
    if (!input) return "";

    let url = input.trim();

    // If only username is entered
    if (!url.includes("linkedin.com")) {
      return `https://www.linkedin.com/in/${url.replace(/^\/+|\/+$/g, "")}/`;
    }

    // Ensure protocol
    if (!/^https?:\/\//i.test(url)) {
      url = "https://" + url;
    }

    try {
      const parsed = new URL(url);

      // Remove subdomains like in.linkedin.com, uk.linkedin.com
      parsed.hostname = "www.linkedin.com";

      // Remove query params and hash
      parsed.search = "";
      parsed.hash = "";

      const pathParts = parsed.pathname.split("/").filter(Boolean);

      if (pathParts[0] === "in" && pathParts[1]) {
        return `https://www.linkedin.com/in/${pathParts[1]}/`;
      }

      return "";
    } catch {
      return "";
    }
  };

  async function getProfileByLinkedin(linkedinUrl) {
    try {
      setLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/lusha/getProfileByLinkedin`,
        {
          linkdin_url: linkedinUrl,
          companyinfo_id: company_id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const data = response.data.row;
      //   setOldCandidate(response.data.row);
      setOldCandidate(data);
    } catch (error) {
      setGlobalLoading(false);
      toastr.error(error.response.data.error);
      reset();
      setCandidate_id(null);
      setLiUrl(false);
      setDisabledFields(false);
      setNotAvailable(true);
    } finally {
      setLoading(false);
    }
  }

  const checkUrlExists = async (url, index) => {
    try {
      if (!url) {
        toastr.error("Please enter a valid LinkedIn URL");
        return;
      }

      const res = await axios.post(
        `${API_BASE_URL}/candidates/candidatecheckByLinkdin/`,
        {
          linkdin_url: url,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res.data.length <= 0) {
        await getProfileByLinkedin(url);
      } else {
        setOldCandidate(res.data[0]);
      }
    } catch (err) {
      console.error(err);
      toastr.error(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Object.keys(oldCandidate).length > 0) {
      setValue("candidate_id", oldCandidate?.id);
      setValue("name", oldCandidate?.firstname + " " + oldCandidate?.lastname);
      setValue("email", oldCandidate?.email || "");
      setValue("designation", oldCandidate?.designation);
      setValue("mobile", oldCandidate?.mobile || oldCandidate?.phone || "");
      setDisabledFields(false);
    }
  }, [oldCandidate]);

  const onSubmit = async (data) => {
    let newData = {};

    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (value) {
        newData[key] = value;
      }
    });

    newData.companyinfo_id = company_id;

    setGlobalLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/companyinfo/add_contact`,
        {
          data: newData,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data?.status === "error") {
        toastr.error(response.data?.message);
      } else {
        toastr.success(response.data?.message);
        reset();
        setContacts([]);
        setCandidate_id(null);
        getContacts();
        setAddContactForm(false);
      }
    } catch (error) {
      console.error("Error adding contact:", error);
    } finally {
      setAddContactForm(false);
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (!candidate_id) {
      return;
    }
    try {
      const candidate = contacts.find((contact) => contact.id === candidate_id);
      console.log(candidate);
      if (candidate) {
        setValue("candidate_id", candidate.id);
        setValue("linkedin_url", candidate.linkdin_url);
        setValue("name", candidate.firstname + " " + candidate.lastname);
        setValue("email", candidate.email || "");
        setValue("designation", candidate.designation);
        setValue("mobile", candidate.mobile || candidate.phone || "");
        setDisabledFields(false);
      }
    } catch (error) {
      console.error(error);
    }
  }, [candidate_id]);

  return (
    <>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        style={{ zIndex: 9999 }}
      >
        <div className="modal-dialog modal-dialog-centered text-center">
          <div className="modal-content modal-content-demo">
            <div className="modal-header">
              <h4 className="modal-title">Contacts</h4>
              <button onClick={onClose} className="btn-close"></button>
            </div>
            <div className="modal-body">
              <div className="row mb-1">
                <div
                  className={`${contacts.length > 0 ? "pipeline_contact_list" : ""} p-1`}
                >
                  {contacts && contacts.length > 0 ? (
                    contacts.map((contact, index) => {
                      if (index % 2 === 0) {
                        return (
                          <div className="row" key={index}>
                            {/* First Column */}
                            <div className="col-md-6">
                              <ContactCard
                                contact={contacts[index]}
                                update={(e) => {
                                  if (e.success === 0) {
                                    toastr.error(e.message);
                                  } else {
                                    toastr.success(e.message);
                                    getContacts();
                                  }
                                }}
                                EditContact={(candidate_id) => {
                                  setCandidate_id(candidate_id);
                                  setAddContactForm(true);
                                }}
                              />
                            </div>

                            {/* Second Column */}
                            {contacts[index + 1] && (
                              <div className="col-md-6">
                                <ContactCard
                                  contact={contacts[index + 1]}
                                  update={(e) => {
                                    if (e.success === 0) {
                                      toastr.error(e.message);
                                    } else {
                                      toastr.success(e.message);
                                      getContacts();
                                    }
                                  }}
                                  EditContact={(candidate_id) => {
                                    setCandidate_id(candidate_id);
                                    setAddContactForm(true);
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        );
                      }
                      return null;
                    })
                  ) : (
                    <div className="pipeline_contact">
                      <div className="pipeline_contact_name">
                        No contacts found
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="row text-center">
                {!AddContactForm && (
                  <button
                    onClick={() => {
                      setAddContactForm(true);
                      setCandidate_id(null);
                    }}
                    className="btn btn-xxl btn-outline-primary rounded-pill"
                  >
                    <i className="fa-solid fa-plus"></i> Add Contact
                  </button>
                )}
              </div>
              {AddContactForm && (
                <>
                  <hr />
                  <div className="row">
                    <div className="col-md-12 ms-auto">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row text-start">
                          <span className="fw-semibold text-dark mb-2">
                            <i
                              className={`fa-solid ${candidate_id ? "fa-user-pen" : "fa-user-plus"}`}
                            ></i>{" "}
                            {candidate_id ? "Edit " : "New "}
                            Contact
                          </span>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label d-flex justify-content-between">
                                <span>
                                  Linkedin URL
                                  <span className="text-danger"> *</span>
                                </span>
                                <span className="d-flex">
                                  <input
                                    type="checkbox"
                                    checked={NotAvailable}
                                    onClick={(e) => {
                                      if (e.target.checked) {
                                        setDisabledFields(false);
                                        setLiUrl(false);
                                        setNotAvailable(true);
                                      } else {
                                        setDisabledFields(true);
                                        setLiUrl(true);
                                        setNotAvailable(false);
                                      }
                                    }}
                                  />
                                  <span className="fw-semibold ms-1">
                                    Not Available
                                  </span>
                                </span>
                              </label>
                              <input
                                type="url"
                                placeholder={
                                  "Enter LinkedIn URL to track your contact's movement across organisations."
                                }
                                autoComplete={"off"}
                                className={`form-control ${errors.linkedin_url ? "is-invalid" : ""}`}
                                {...register("linkedin_url", {
                                  required: LiUrl ? true : false,
                                  validate: (value) => {
                                    if (!value) return true; // allow empty
                                    // const pattern =
                                    //   /^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/i;
                                    const pattern =
                                      /^(https?:\/\/)?([\w]+\.)?linkedin\.com\/.*$/i;

                                    return (
                                      pattern.test(value) ||
                                      "Enter a valid LinkedIn URL"
                                    );
                                  },
                                })}
                                onBlur={(e) => {
                                  const rawValue = e.target.value.trim();

                                  const normalized =
                                    normalizeLinkedInUrl(rawValue);

                                  if (!normalized) {
                                    return;
                                  }

                                  e.target.value = normalized; // overwrite input with clean URL
                                  setLoading(true);
                                  checkUrlExists(normalized);
                                }}
                                disabled={LiUrl ? false : true}
                                // onPaste={(e) => {
                                //   setTimeout(() => {
                                //     const rawValue = e.target.value.trim();

                                //     const normalized =
                                //       normalizeLinkedInUrl(rawValue);

                                //     if (!normalized) return;

                                //     e.target.value = normalized;
                                //     setLoading(true);
                                //     checkUrlExists(normalized);
                                //   }, 10);
                                // }}
                              />
                            </div>
                          </div>
                          {loading ? (
                            <Skeleton height={100} count={1} />
                          ) : (
                            <>
                              <div className="row text-start">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Name
                                      <span className="text-danger"> *</span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                      placeholder={"Enter Name"}
                                      autoComplete={"off"}
                                      disabled={disabledFields}
                                      {...register("name", { required: true })}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Designation
                                      <span className="text-danger"> *</span>
                                    </label>
                                    <input
                                      type="text"
                                      placeholder={"Enter Designation"}
                                      autoComplete={"off"}
                                      disabled={disabledFields}
                                      className={`form-control ${errors.designation ? "is-invalid" : ""}`}
                                      {...register("designation", {
                                        required: true,
                                      })}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row text-start">
                                <div className="col-md-6 ">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Email
                                      {errors.email && (
                                        <span className="text-danger ms-1">
                                          {errors.email.message}
                                        </span>
                                      )}
                                    </label>
                                    <input
                                      type="email"
                                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                      autoComplete={"off"}
                                      placeholder={"Enter Email"}
                                      disabled={disabledFields}
                                      {...register("email", {
                                        required: false,
                                        validate: (value) => {
                                          if (!value) return true;
                                          const pattern =
                                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                          return (
                                            pattern.test(value) ||
                                            "Enter a valid email address"
                                          );
                                        },
                                      })}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Mobile
                                      {errors.mobile && (
                                        <span className="text-danger ms-1">
                                          {errors.mobile.message}
                                        </span>
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      autoComplete={"off"}
                                      placeholder={"Enter Mobile"}
                                      disabled={disabledFields}
                                      {...register("mobile", {
                                        required: false,
                                        valueAsNumber: true,
                                        validate: (value) => {
                                          if (!value) return true;
                                          const pattern = /^[0-9]{10}$/;
                                          return (
                                            pattern.test(value) ||
                                            "Enter a valid mobile number"
                                          );
                                        },
                                      })}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>

                        <div className="row">
                          <div className="col-md-12 d-flex justify-content-end">
                            <button
                              className="btn btn-md btn-primary rounded-pill"
                              type="submit"
                              disabled={loading}
                            >
                              Save
                            </button>
                            <button
                              className="ms-2 btn btn-md btn-danger rounded-pill"
                              type="button"
                              onClick={() => {
                                reset();
                                setAddContactForm(false);
                                setCandidate_id(null);
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddContacts;
